<template>
  <v-app>
    <AppAlert />
    <v-main>
      <v-container fluid class="py-0">
        <v-row>
          <v-col cols="12" class="d-flex flex-wrap pb-0 pt-6">
            <h1 class="text-h5">{{ $t("app.title") }}</h1>
            <v-spacer></v-spacer>
            <div>
              <LocaleChanger />
            </div>
            <v-btn
              class="ml-4"
              small
              color="transparent"
              elevation="2"
              @click="toggleIsShowingInstructionIcons"
              >{{ instructionButtonText }}</v-btn
            >
            <v-btn
              class="ml-4"
              small
              color="transparent"
              elevation="2"
              href="http://localhost:9009"
              target="_blank"
              >{{ $t("app.tutorials") }}</v-btn
            >
          </v-col>
          <v-col cols="12" lg="6">
            <SankeyChart />
          </v-col>
          <v-col cols="12" lg="6">
            <WordCloud />
          </v-col>
          <v-col cols="12">
            <SentimentYearChart />
          </v-col>
          <v-col cols="12">
            <ThemesLineChart />
          </v-col>
          <v-col cols="12">
            <RankTables />
          </v-col>
          <v-col cols="12">
            <PoemPanel />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SankeyChart from "./components/SankeyChart/index";
import WordCloud from "./components/WordCloud/index";
import ThemesLineChart from "./components/ThemesLineChart/index";
import RankTables from "./components/RankTables/index";
import SentimentYearChart from "./components/SentimentYearChart/index";
import PoemPanel from "./components/PoemPanel/";
import LocaleChanger from "./components/LocaleChanger";
import AppAlert from "./components/AppAlert";

export default {
  components: {
    SankeyChart,
    WordCloud,
    ThemesLineChart,
    RankTables,
    SentimentYearChart,
    PoemPanel,
    LocaleChanger,
    AppAlert
  },
  computed: {
    ...mapState(["isShowingInstructionIcons"]),
    instructionButtonText() {
      return this.isShowingInstructionIcons
        ? this.$t("app.hideInstructionIcons")
        : this.$t("app.showInstructionIcons");
    }
  },
  created() {
    const locale = localStorage.getItem("locale") || "zhHans"; //"en";
    this.$i18n.locale = locale;
    this.$vuetify.lang.current = locale;
    this.$store.dispatch("updateLocale", locale);
  },
  methods: {
    ...mapMutations(["updateIsShowingInstructionIcons"]),
    toggleIsShowingInstructionIcons() {
      this.updateIsShowingInstructionIcons(!this.isShowingInstructionIcons);
    }
  }
};
</script>
